'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _LoggedIn = require('./LoggedIn');

var _LoggedIn2 = _interopRequireDefault(_LoggedIn);

var _LoggedOut = require('./LoggedOut');

var _LoggedOut2 = _interopRequireDefault(_LoggedOut);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Login = function (_Component) {
    (0, _inherits3.default)(Login, _Component);

    function Login() {
        (0, _classCallCheck3.default)(this, Login);
        return (0, _possibleConstructorReturn3.default)(this, (Login.__proto__ || (0, _getPrototypeOf2.default)(Login)).apply(this, arguments));
    }

    (0, _createClass3.default)(Login, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['userLoggedIn', 'windowWidth']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                baseUrl = _props.baseUrl,
                logOutBidder = _props.logOutBidder,
                mobile = _props.mobile,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal,
                parent = _props.parent,
                userLoggedIn = _props.userLoggedIn,
                whiteLabel = _props.whiteLabel,
                windowWidth = _props.windowWidth;


            return userLoggedIn ? (0, _jsx3.default)(_LoggedIn2.default, {
                baseUrl: baseUrl,
                logOutBidder: logOutBidder,
                mobile: mobile,
                parent: parent,
                whiteLabel: whiteLabel,
                windowWidth: windowWidth
            }) : (0, _jsx3.default)(_LoggedOut2.default, {
                openCreateAccountModal: openCreateAccountModal,
                openLoginModal: openLoginModal
            });
        }
    }]);
    return Login;
}(_react.Component);

exports.default = Login;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Login/Login.js
// module id = vC/J
// module chunks = 57